/**
 *
 * ErrorMessage
 *
 */
import React, { memo } from 'react';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';

interface Props {
  error: string | undefined | null;
}

export const ErrorMessage = memo((props: Props) => {
  return props.error ? (
    <div className="error-message d-flex align-items-center text-danger">
      <ErrorRoundedIcon
        className="mr-1"
        style={{ color: '#ff0000', fontSize: 14 }}
      />
      {props.error}
    </div>
  ) : null;
});
